import posthog from 'posthog-js'

import { DotEntryForm, trackDotEntered, trackMetaEvent } from '@/lib/analytics'
import type { InsuranceApplication } from '@/models/insuranceApplication'

// The intake the "Get your quotes" front door stamps on its stub accounts' applications.
const FRONT_DOOR_INTAKE = 'anonymous'

export enum DotStepService {
  ADD = 'ADD_DOT_NUMBER',
  CONFIRM = 'CONFIRM_DOT_NUMBER',
}

/**
 * Report the DOT a customer typed into the chat the way the estimates page reports
 * its own. Tag Manager hears about every resolved DOT, as the backend counts them;
 * PostHog and Meta only about the front door's.
 */
export function trackFrontDoorDotResult(application: InsuranceApplication, dotNumber: string) {
  // The DOT step only moves on to confirming the carrier once the lookup found it.
  const resolved = application.nextService === DotStepService.CONFIRM
  if (resolved) trackDotEntered(dotNumber, DotEntryForm.APPLICATION_START)
  if (application.metadata?.intake !== FRONT_DOOR_INTAKE) return
  posthog.capture('insure_dot_number_result', {
    dot_number: dotNumber,
    outcome: resolved ? 'success' : 'error',
    flow: 'application_start',
  })
  if (!resolved) return
  trackMetaEvent(
    'Lead',
    { content_category: 'insurance_estimate', content_name: 'dot_submitted' },
    application.id
  )
}
